// SLA colour logic — T2T-04 §8. Used by List, Kanban, Calendar views.

export function getSlaStatus(dueAt, slaMinutes) {
  if (!dueAt) return { status: "no_sla", color: "gray", label: "No SLA" };
  const now         = new Date();
  const due         = new Date(dueAt);
  const msRemaining = due - now;
  const msTotal     = (slaMinutes || 1440) * 60 * 1000;
  const pct         = msRemaining / msTotal;

  if (msRemaining < 0) {
    const h = Math.abs(msRemaining) / 3600000;
    return { status: "breached", color: "red", label: `${h.toFixed(1)}h overdue` };
  }
  if (pct < 0.2) {
    const h = msRemaining / 3600000;
    return { status: "at_risk", color: "amber", label: `${h.toFixed(1)}h remaining` };
  }
  const h = msRemaining / 3600000;
  return { status: "on_track", color: "green", label: `${h.toFixed(1)}h remaining` };
}

export function slaBadgeClass(status) {
  return {
    breached: "t2t-badge t2t-badge-sla-breached",
    at_risk:  "t2t-badge t2t-badge-sla-at_risk",
    on_track: "t2t-badge t2t-badge-sla-on_track",
    no_sla:   "t2t-badge t2t-badge-sla-no_sla",
  }[status] || "t2t-badge t2t-badge-sla-no_sla";
}

export function slaBorderClass(status) {
  return {
    breached: "sla-breached",
    at_risk:  "sla-at-risk",
    on_track: "sla-on-track",
    no_sla:   "",
  }[status] || "";
}
